import { Injectable } from '@angular/core';
import { Address } from '@xt/domain-model';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AddressAdapter {
  fromResource$(
    fhirAddress: fhir4.Address | fhir4.Address[],
    type: fhir4.Address['type'] = 'physical',
  ): Observable<Address> {
    const _resource = Array.isArray(fhirAddress)
      ? fhirAddress.find((address: fhir4.Address) => address.type === type) ||
        fhirAddress[0]
      : fhirAddress || {};

    const zip = _resource.postalCode;
    const city = _resource.city;
    const street = _resource.line?.join(' ');
    const country = _resource.country;
    const display = _resource.text || `${zip} ${city}, ${street}`;

    const addressDetails = {
      zip,
      city,
      street,
      country,
      display,
    };

    return of(addressDetails);
  }
}
